import { ManagementCompany } from "../Interfaces"
import { OWNER } from "./roles"

/** Same gate as the existing Construction Companies / management-companies nav. */
export function isCompanyAdmin(roleId?: number | null): boolean {
  return typeof roleId === "number" && roleId > OWNER
}

/** Owner (40) and up can add/edit/delete Sage employees, job sites, and job codes. */
export function canManageSageMasterData(roleId?: number | null): boolean {
  return typeof roleId === "number" && roleId >= OWNER
}

export function formatCompanyContext(company: Pick<ManagementCompany, "name" | "code">): string {
  const name = (company.name || "").trim()
  const code = (company.code || "").trim().toUpperCase()
  if (name && code) return `${name} · ${code}`
  return name || code
}

export function normalizeCompany(raw: unknown): ManagementCompany {
  const body = (raw && typeof raw === "object" ? raw : {}) as Record<string, unknown>
  const nested = body.company && typeof body.company === "object"
    ? body.company as Record<string, unknown>
    : body
  const id = Number(nested.id)
  if (!id) {
    throw new Error("Company response is missing an id")
  }
  return {
    id,
    name: String(nested.name ?? "").trim(),
    code: String(nested.code ?? nested.shortCode ?? "").trim().toUpperCase(),
    address: nested.address != null ? String(nested.address) : undefined,
    city: nested.city != null ? String(nested.city) : undefined,
    state: nested.state != null ? String(nested.state) : undefined,
    zipcode: nested.zipcode != null ? String(nested.zipcode) : undefined,
    phone: nested.phone != null ? String(nested.phone) : undefined,
    email: nested.email != null ? String(nested.email) : undefined,
    logoUrl: nested.logoUrl != null ? String(nested.logoUrl) : undefined,
    website: nested.website != null ? String(nested.website) : undefined,
    ownerId: nested.ownerId != null ? Number(nested.ownerId) : undefined,
  }
}

export function normalizeCompanyList(raw: unknown): ManagementCompany[] {
  if (Array.isArray(raw)) {
    return raw.map((item) => normalizeCompany(item))
  }
  if (raw && typeof raw === "object") {
    const body = raw as Record<string, unknown>
    const list = body.companies ?? body.data ?? body.items
    if (Array.isArray(list)) {
      return list.map((item) => normalizeCompany(item))
    }
  }
  return []
}

export const SELECTED_COMPANY_STORAGE_KEY = "cw.selectedCompany"
